export let table = {
  type: "table", // table, setting
  table: {
    tab: [
      { tab_name: "tab 1", //tab over table
       path: `/tab_1`, // path for get api
        isShow: true, //on | off tab
         isActive: true }, // ui active
      { tab_name: "tab_2",
       path: `/tab 2`,
        isShow: true,
         isActive: false },
    ],
    data: [
      {
        number: 1,
        string: "string ja",
        date: "2021-03-02",
        detail:1, //id & router
        delete: 1, //id
        float: 3.0, 
        array: ["0", "1", "2", "3"], //array string array obj must be customize
        dropdown:"a",
        dropdown_choice:[ // select options dropdown ถ้ามี dropdownมีมากกว่า1ต้องcustomizeเพิ่ม
          {name:"a" // text select in option
          ,postTo:"url"// url for post || put 
        },
        {name:"b",
        postTo:"url"
      },
        {name:"c",
        postTo:"url"
      }]
      },
      {
        number: 2,
        string: "string ja",
        date: "2021-03-02",
        detail:1, //column type: iconDetail, Edit, Publish ส่งมาเป็น obj ข้างในมี id และ router
        delete: 2, //id
        float: 3.0,
        array: ["0", "1", "2", "3"],
        dropdown:"a",//ตัวเลือกปัจจุบัน
        dropdown_choice:[{name:"a",postTo:"url"},{name:"b",postTo:"url"},{name:"c",postTo:"url"}]//name: ชื่อของตัวเลือกใน dropdown ,postTo ใส่ url เพื่อทำการpostไปยังurl ที่กำหนด
      },
    ], // data in table
    column: [
      {
        headerName: "INT", // head column
        field: "number", // attr in data
        cellRendererFramework: "Number", // render type
      },
      {
        headerName: "String",
        field: "string",
        cellRendererFramework: "String",
      },
      {
        headerName: "Date",
        field: "date",

        cellRendererFramework: "Date",
      },
      {
        headerName: "Detail",
        field: "detail",
        cellRendererFramework: "iconDetail", //column type: iconDetail, Edit, Publish ส่งมาเป็น obj ข้างในมี id และ router
      },
      {
        headerName: "Delete",
        field: "delete",
        cellRendererFramework: "iconDelete",
      },
      {
        headerName: "Float",
        field: "float",
        cellRendererFramework: "Float",
      },
      {
        headerName: "Array",
        field: "array",
        cellRendererFramework: "Array",
      },
      {
        headerName: "Dropdown",
        field: "dropdown",
        cellRendererFramework: "Dropdown",
      },
    ], // column in table
    filter_button: {
      value:true,
      column:[
        {
      name:["String"], // options column 
      filter:["stringja","abcd","xxxx"] // option filter
    }
  ]}, // เปิดปุ่ม filter
    add_button: {
      name:"เพิ่ม" , // text in btn
      value:true, //on||off btn
      to:"/detail" //router
    }, // เปิดปุ่ม add
   
  },
};
export let banner = {
  type: "table", // table,  setting
  table: {
    tab: [
      { tab_name: "tab 1", //tab over table
        path: `/tab_1`, // path for get api
        isShow: true, //on | off tab
        isActive: true }, // ui active
      { tab_name: "tab_2",
        path: `/tab 2`,
        isShow: true,
        isActive: false },

    ],
    data: [
      {
        no: 1,
        title: "string ja",
        startDate: "2021-03-02",
        endDate: "2021-05-02",
       th:true,
       en:true,
       cn:true,
        array: ["0", "1", "2", "3"],
        publish:{
          value:true,
          id:1
        },//column type: iconDetail, Edit, Publish ส่งมาเป็น obj ข้างในมี id และ router
        edit:5,//column type: iconDetail, Edit, Publish ส่งมาเป็น obj ข้างในมี id และ router
        delete:1,//id
        detail:1
      },
     
    ], // data in table
    column: [
      {
        headerName: "No",
        field: "no",
        cellRendererFramework: "Number",
        width : 100
      },
      {
        headerName: "Title",
        field: "title",
        cellRendererFramework: "String",
        width : 300
      },
      {
        headerName: "startDate",
        field: "startDate",
        width : 100,
        cellRendererFramework: "Date",
      },
      {
        headerName: "endDate",
        field: "endDate",

        cellRendererFramework: "Date",
      },
      {
        headerName: "TH",
        field: "th",
        cellRendererFramework: "String",
      },
      {
        headerName: "EN",
        field: "en",
        cellRendererFramework: "String",
      },
      {
        headerName: "CN",
        field: "cn",
        cellRendererFramework:"String",
      },
      {
        headerName: "Publish",
        field: "publish",
        cellRendererFramework:"TogglePublic", //column type: iconDetail, Edit, Publish ส่งมาเป็น obj ข้างในมี id และ router
      },
      {
        headerName: "Edit",
        field: "edit",
        cellRendererFramework:"Edit", //column type: iconDetail, Edit, Publish ส่งมาเป็น obj ข้างในมี id และ router
      },
      {
        headerName: "Delete",
        field: "delete",
        cellRendererFramework:"Delete",
      },
      {
        headerName: "รายละเอียด",
        field: "detail",
        cellRendererFramework:"Detail",
      },
     
    ], // column in table
    filter_button: {
      value:false,
    }, // เปิดปุ่ม filter
    add_button: {
      name:"เพิ่มผู้สอน" , // text in btn
      value:true, //on||off btn
      to:"/addlecturer" //router
    }, // เปิดปุ่ม add
  },
};

export let setting ={
  type:"setting",
  isAddRole:true, // on|| off add button
  role:[
    {
      admin_id:1, //id position admin
      name:"Super Admin", // text 
      access:[
        {
          name:"Dashboard", // page
          value:true,
          actions:[
            {
            name:"View", // action
            value:true // value of action // true = ทำได้ false = ทำไม่ได้
          },
          {
            name:"Export", // action
            value:true // value of action // true = ทำได้ false = ทำไม่ได้
          },
        ]
        }
      ],
    },
    {
      admin_id:2,
      name:"Admin(QR)",
      access:[
        {
          name:"Dashboard",
          value:false,
          actions:[
            {
            name:"View",
            value:false
          },
          {
            name:"Export",
            value:false
          },
        ]
        }
      ]
    }
  ]
}

 export const tableAndHorizal = {
  "status": "success",
  "data": {
    "componentDetail": {
      "table": {
        "value": true,
        "componentClass": "col-span-2"
      },
      "horizontalCard": {
        "value": true,
        "componentClass": "col-span-1 pad-tob-20"
      },
      "verticalCard": {
        "value": false,
        "componentClass": "col-span-1"
      },
      "board": {
        "value": false,
        "componentClass": "col-span-1"
      },
      "divClass": "grid grid-cols-3 gap-4"
    },
    "data": {
      "image": {
        "name": null,
        "value": [
          {
            "link": "https://storage.googleapis.com/castonly_bucket/profile-65-20210217-212757.jpg"
          }
        ],
        "type": "Image",
        "isShow": true,
        "style": {
          "width": 100,
          "height": 100,
          "class": "rounded-full"
        }
      },
      "name": {
        "name": null,
        "value": "zaii tester",
        "type": "String",
        "isShow": true,
      },
      "id_user": {
        "name": "ID",
        "value": "65",
        "type": "String",
        "isShow": true,
        "divClass": "grid grid-cols-3 divide-x",
        "style": {
          "class": "py-2 px-5 text-primary text-base",
          "divClassFirst": "col-span-1",
          "divClassSecond": "col-span-2"
        }
      },
      "email": {
        "name": "Email",
        "value": "p2@gmail.com",
        "type": "String",
        "isShow": true,
        "divClass": "grid grid-cols-3 divide-x",
        "style": {
          "class": "py-2 px-5 text-primary text-base",
          "divClassFirst": "col-span-1",
          "divClassSecond": "col-span-2"
        }
      },
      "sex": {
        "name": "Sex",
        "value": "male",
        "type": "String",
        "isShow": true,
        "divClass": "grid grid-cols-3 divide-x",
        "style": {
          "class": "py-2 px-5 text-primary text-base",
          "divClassFirst": "col-span-1",
          "divClassSecond": "col-span-2"
        }
      },
      "birthday": {
        "name": "Birthday",
        "value": "1995-02-08T00:00:00.000Z",
        "type": "Date",
        "isShow": true,
        "divClass": null,
        "style": {
          "class": "py-2 px-5 text-primary text-base"
        }
      },
      "phone": {
        "name": "Phone Number",
        "value": "0804591828",
        "type": "String",
        "isShow": true,
        "divClass": "grid grid-cols-3 divide-x",
        "style": {
          "class": "py-2 px-5 text-primary text-base",
          "divClassFirst": "col-span-1",
          "divClassSecond": "col-span-2"
        }
      },
      "location": {
        "name": "Current location",
        "value": {
          "country": {
            "name": null,
            "value": "Thailand",
            "isShow": true,
            "style": {
              "class": "text-primary text-base"
            }
          },
          "province": {
            "name": null,
            "value": "Bangkok",
            "isShow": true,
            "style": {
              "class": "text-primary text-base"
            }
          },
          "district": {
            "name": null,
            "value": null,
            "isShow": true,
            "style": {
              "class": "text-primary text-base"
            }
          }
        },
        "type": "Object",
        "isShow": true,
        "divClass": "grid grid-cols-3 divide-x",
        "style": {
          "class": "py-2 px-5 text-primary text-base",
          "divClassFirst": "col-span-1",
          "divClassSecond": "col-span-2"
        }
      }
    }
  }
}
export const board = {
  "status": "success",
  "data": {
    "componentDetail": {
      "table": {
        "value": false,
        "componentClass": "col-span-2"
      },
      "horizontalCard": {
        "value": false,
        "componentClass": "col-span-1 pad-tob-20"
      },
      "verticalCard": {
        "value": false,
        "componentClass": "col-span-1"
      },
      "board": {
        "value": true,
        "componentClass": "col-span-1"
      },
      "divClass": "col-12 py-5"
    },
    "data": {
      "right_top_text": {
        "name": "Status :",
        "value": "Complete",
        "type": "String",
        "isShow": true,
        "divClass": "flex justify-end",
        "style": {
          "class": "py-2 px-0 text-primary text-lg font-semibold",
          "divClassFirst": "",
          "divClassSecond": "px-1"
        }
      },
      "photo": {
        "name": "Photos (4/7)",
        "value": [
          {
            "link": "https://storage.googleapis.com/castonly_bucket/profile-130-20210423-142609.jpeg"
          },
          {
            "link": "https://storage.googleapis.com/castonly_bucket/profile-130-20210423-142635.jpeg"
          },
          {
            "link": "https://storage.googleapis.com/castonly_bucket/profile-130-20210423-142658.jpeg"
          },
          {
            "link": "https://storage.googleapis.com/castonly_bucket/profile-130-20210423-142712.jpeg"
          }
        ],
        "type": "Image",
        "isShow": true,
        "style": {
          "width": 120,
          "height": 130,
          "class": "mr-4"
        },
        "divClass": "flex width-auto"
      },
      "casting_video": {
        "name": "Casting video",
        "value": [
          {
            "link": "https://www.youtube.com/watch?v=Ba6EkXSpkgI"
          }
        ],
        "type": "Video",
        "isShow": true,
        "style": {
          "width": 330,
          "height": 200,
          "class": "mr-4"
        },
        "divClass": "flex"
      },
      "weight_height": {
        "name": "Weight & Height",
        "value": {
          "weight": {
            "name": "Weight (kg.)",
            "value": 68,
            "style": {
              "class": "text-primary text-base"
            }
          },
          "height": {
            "name": "Height (kg.)",
            "value": 174,
            "style": {
              "class": "text-primary text-base"
            }
          }
        },
        "isShow": true,
        "type": "Object",
        "divClass": "flex",
        "style": {
          "class": "text-primary text-base",
          "divClassFirst": "mr-5 ",
          "divClassSecond": ""
        }
      },
      "language": {
        "name": "Language",
        "value": {
          "first": {
            "name": "Mother Language & Accent",
            "value": "English",
            "style": {
              "class": "text-primary text-base"
            }
          },
          "second": {
            "name": "2nd Language & Accent",
            "value": "Thai",
            "style": {
              "class": "text-primary text-base"
            }
          },
          "third": {
            "name": "3rd Language & Accent",
            "value": "-",
            "style": {
              "class": "text-primary text-base"
            }
          }
        },
        "isShow": true,
        "type": "Object",
        "divClass": "flex",
        "style": {
          "class": "text-primary text-base",
          "divClassFirst": "mr-5 ",
          "divClassSecond": ""
        }
      },
      "experiences": {
        "name": "Experiences",
        "value": [
          {
            "title": {
              "name": "#1",
              "value": "Final Boss",
            },
            "year": {
              "name": "Year",
              "value": 1997,
            },
            "role": {
              "name": "Role",
              "value": "Actor",
            },
            "link": {
              "name": "Link",
              "value": "https://snk.fandom.com/wiki/Orochi",
            }
          }
        ],
        "isShow": true,
        "type": "ArrayObject",
        
      },
      "costume_sheet": {
        "name": "Costume sheet",
        "value": {
          "shirt": {
            "name": "Shirt Size",
            "value": "XL",
            "style": {
              "class": "text-primary text-base"
            }
          },
          "jacket": {
            "name": "Jacket size",
            "value": "-",
            "style": {
              "class": "text-primary text-base"
            }
          },
          "pant": {
            "name": "Pant size",
            "value": "XL",
            "style": {
              "class": "text-primary text-base"
            }
          },
          "shoes": {
            "name": "Shoes size",
            "value": "US 13",
            "style": {
              "class": "text-primary text-base"
            }
          },
          "head": {
            "name": "Head (Inches)",
            "value": "-",
            "style": {
              "class": "text-primary text-base"
            }
          },
          "neck": {
            "name": "Neck (Inches)",
            "value": "-",
            "style": {
              "class": "text-primary text-base"
            }
          },
          "bust": {
            "name": "Bust (Inches)",
            "value": 30,
            "style": {
              "class": "text-primary text-base"
            }
          },
          "waist_floor": {
            "name": "Waist floor (Inches)",
            "value": "-",
            "style": {
              "class": "text-primary text-base"
            }
          },
          "waist_knee": {
            "name": "Waist knee (Inches)",
            "value": "-",
            "style": {
              "class": "text-primary text-base"
            }
          },
          "upper_hip": {
            "name": "Upper hip (Inches)",
            "value": "-",
            "style": {
              "class": "text-primary text-base"
            }
          },
          "lower_hip": {
            "name": "Lower hip (Inches)",
            "value": 40,
            "style": {
              "class": "text-primary text-base"
            }
          }
        },
        "isShow": true,
        "type": "Object",
        "divClass": "flex",
        "style": {
          "class": "text-primary text-base",
          "divClassFirst": "",
          "divClassSecond": ""
        }
      },
      "miscellaneous": {
        "name": "Miscellaneous",
        "value": {
          "nude_scene": {
            "name": "Nudity scene :",
            "value": "Can accept",
            "style": {
              "class": "text-primary text-base"
            }
          },
          "kiss_scene": {
            "name": "Kissing scene :",
            "value": "Can not accept",
            "style": {
              "class": "text-primary text-base"
            }
          },
          "smoke_scence": {
            "name": "Smoking scene :",
            "value": "Can accept",
            "style": {
              "class": "text-primary text-base"
            }
          },
          "change_hair": {
            "name": "Cutting or change hair color :",
            "value": "Can not accept",
            "style": {
              "class": "text-primary text-base"
            }
          }
        },
        "isShow": true,
        "type": "Object",
        "divClass": "flex",
        "style": {
          "class": "text-primary text-base",
          "divClassFirst": "mr-5 ",
          "divClassSecond": ""
        }
      },
      "tags": [
        {
          "name": "หล่อ",
          "selectTag": true,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "สวย",
          "selectTag": true,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "หมวย",
          "selectTag": true,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "สูง",
          "selectTag": false,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "ลูกครึ่ง",
          "selectTag": false,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "ฝรั่ง",
          "selectTag": false,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "คม",
          "selectTag": false,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "ยูนิค",
          "selectTag": false,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "แนวๆ",
          "selectTag": true,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "เตี้ย",
          "selectTag": false,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "หุ่นดี",
          "selectTag": true,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "ลีน",
          "selectTag": true,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "อวบ",
          "selectTag": true,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "รอยสัก",
          "selectTag": false,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "อ้วน",
          "selectTag": true,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "ตี๋",
          "selectTag": false,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "จีน",
          "selectTag": false,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "ไทย",
          "selectTag": false,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "ขาว",
          "selectTag": false,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "เข้ม",
          "selectTag": false,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "แทน",
          "selectTag": false,
          "isDelete": false,
          "fixed": true
        },
        {
          "name": "สุดเท่",
          "selectTag": true,
          "isDelete": false
        },
        {
          "name": "x",
          "selectTag": false,
          "isDelete": false
        },
        {
          "name": "c",
          "selectTag": true,
          "isDelete": false
        }
      ]
    }
  }
}